// extracted by mini-css-extract-plugin
export var heroImage = "_mg-1";
export var modal = "_mg-0";